import { create } from 'zustand';

import type { AdminSortKey, AdminStatus, SortDirection } from '../types/admin.types';

export interface AdminListFilters {
  // '' = "All Roles". '__ROOT__' = isRoot only. Any other string = role name.
  role: string;
  // '' = "All Statuses".
  status: AdminStatus | '';
  search: string;
}

export interface AdminListSort {
  key: AdminSortKey;
  dir: SortDirection;
}

interface AdminListState {
  filters: AdminListFilters;
  sort: AdminListSort;
  page: number;
  setFilters: (partial: Partial<AdminListFilters>) => void;
  // Same key → toggle dir; new key → asc.
  toggleSort: (key: AdminSortKey) => void;
  setPage: (page: number) => void;
  reset: () => void;
}

const INITIAL_FILTERS: AdminListFilters = { role: '', status: '', search: '' };
// PRD 15 §3.1: default sort is ID descending (most recently registered first).
const INITIAL_SORT: AdminListSort = { key: 'id', dir: 'desc' };

export const useAdminListStore = create<AdminListState>((set) => ({
  filters: INITIAL_FILTERS,
  sort: INITIAL_SORT,
  page: 1,
  // Filter or sort changes reset pagination to page 1 (prototype behavior).
  setFilters: (partial) =>
    set((s) => ({ filters: { ...s.filters, ...partial }, page: 1 })),
  toggleSort: (key) =>
    set((s) => ({
      sort:
        s.sort.key === key
          ? { key, dir: s.sort.dir === 'asc' ? 'desc' : 'asc' }
          : { key, dir: 'asc' },
      page: 1,
    })),
  setPage: (page) => set({ page }),
  reset: () => set({ filters: INITIAL_FILTERS, sort: INITIAL_SORT, page: 1 }),
}));
